export const OPEN_CREATE_PROJECT_NOTE_EVENT = 'open-create-project-note';

export function openCreateProjectNoteDialog(projectId: string): void {
  window.dispatchEvent(
    new CustomEvent(OPEN_CREATE_PROJECT_NOTE_EVENT, {
      detail: { projectId },
    }),
  );
}
